<!-- Toast Notification -->
<div class="toast-container" *ngIf="showToast">
  <div class="toast" [class.toast-success]="toastType === 'success'" [class.toast-error]="toastType === 'error'">
    <div class="toast-content">
      <svg *ngIf="toastType === 'success'" class="toast-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
        <polyline points="22 4 12 14.01 9 11.01"></polyline>
      </svg>
      <svg *ngIf="toastType === 'error'" class="toast-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="15" y1="9" x2="9" y2="15"></line>
        <line x1="9" y1="9" x2="15" y2="15"></line>
      </svg>
      <span>{{ toastMessage }}</span>
    </div>
    <button class="toast-close" (click)="closeToast()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
  </div>
</div>

<div class="main-wrapper">
  <!-- Navigation -->
  <nav class="navbar" [class.navbar-scrolled]="isScrolled" data-testid="main-navigation">
    <div class="container navbar-container">
      <!-- <div class="navbar-logo" data-testid="clinic-logo">
        Enlighten Physio Spot
      </div> -->
      <div class="navbar-logo" data-testid="clinic-logo">
      <img
        src="assets/fulllogo.png"
        alt="Enlighten Physio Spot logo"
        class="navbar-logo-image"
      />
      <span class="navbar-logo-text">Enlighten Physio Spot</span>
    </div>

      <!-- Desktop Menu -->
      <div class="navbar-menu desktop-menu">
        <button class="nav-link" (click)="scrollToSection('services')" data-testid="nav-services">
          Services
        </button>
        <button class="nav-link" (click)="scrollToSection('about')" data-testid="nav-about">
          About
        </button>
        <button class="nav-link" (click)="scrollToSection('team')" data-testid="nav-team">
          Team
        </button>
        <button class="nav-link" (click)="scrollToSection('testimonials')" data-testid="nav-testimonials">
          Testimonials
        </button>
        <button class="btn btn-accent btn-rounded" (click)="scrollToSection('appointment')" data-testid="nav-book-appointment">
          Book Appointment
        </button>
      </div>

      <!-- Mobile Menu Button -->
      <button class="mobile-menu-toggle" (click)="toggleMobileMenu()" data-testid="mobile-menu-toggle">
        <svg *ngIf="!mobileMenuOpen" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="3" y1="12" x2="21" y2="12"></line>
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <line x1="3" y1="18" x2="21" y2="18"></line>
        </svg>
        <svg *ngIf="mobileMenuOpen" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <!-- Mobile Menu -->
    <div class="mobile-menu" *ngIf="mobileMenuOpen" data-testid="mobile-menu">
      <div class="container">
        <button class="nav-link" (click)="scrollToSection('services')">Services</button>
        <button class="nav-link" (click)="scrollToSection('about')">About</button>
        <button class="nav-link" (click)="scrollToSection('team')">Team</button>
        <button class="nav-link" (click)="scrollToSection('testimonials')">Testimonials</button>
        <button class="btn btn-accent btn-rounded btn-full" (click)="scrollToSection('appointment')">
          Book Appointment
        </button>
      </div>
    </div>
  </nav>

  <!-- Hero Section -->
  <section class="hero-section" data-testid="hero-section" data-track-section="hero">
    <div class="hero-bg">
      <img src="https://images.pexels.com/photos/5215017/pexels-photo-5215017.jpeg" 
           alt="Physiotherapist helping patient with rehabilitation exercises" 
           class="hero-bg-image" />
      <div class="hero-overlay"></div>
    </div>
    
    <div class="container hero-content">
      <div class="hero-grid">
        <div class="hero-text">
          <!-- <p class="hero-tagline" data-testid="hero-tagline">We Are Here For You</p> -->
          <h1 class="hero-title" data-testid="hero-title">
            Assessing and treating in Enlightened path
          </h1>
          <p class="hero-description" data-testid="hero-description">
            Helps you to provide information, right treatment and make sure understanding the true fact about Pain, Rehab, physical fitness, Injury prevention and management to progress your Quality of life.
          </p>
          
          <div class="hero-buttons">
            <button class="btn btn-primary btn-rounded btn-lg shadow-lg" (click)="scrollToSection('appointment')" data-testid="hero-book-appointment-btn">
              Book Appointment
            </button>
            <a *ngIf="clinicSettings.phone_numbers[0]" 
               [href]="'tel:' + clinicSettings.phone_numbers[0]" 
               class="btn btn-outline btn-rounded btn-lg"
               data-testid="hero-call-now-btn">
              <!-- <svg class="btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
              </svg> -->
              Call Now
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Services Section -->
  <section class="section section-services" id="services" data-testid="services-section" data-track-section="services">
    <div class="container">
      <div class="section-header">
        <p class="section-tagline">Our Services</p>
<div class="carousel-container">
  <div class="carousel-track">
    <div class="carousel-item" *ngFor="let item of ImageTextItem">
      <img [src]="item.image" [alt]="item.title" />
      <h3>{{ item.title }}</h3>
    </div>
    <!-- Duplicate items for seamless loop -->
    <div class="carousel-item" *ngFor="let item of ImageTextItem">
      <img [src]="item.image" [alt]="item.title" />
      <h3>{{ item.title }}</h3>
    </div>
  </div>
</div>
        <!-- here i want a image auto scroll left right with animation -->
        <h2 class="section-title">Special High-Quality Services</h2>
      </div>
      
      <div class="services-grid">
        <div *ngFor="let service of services; let i = index" 
             class="service-card" 
             [class.service-featured]="service.featured"
             [attr.data-testid]="'service-card-' + i">
          <div class="service-card-content">
            <div class="service-icon"
                [innerHTML]="getServiceIcon(service.icon.svg)">
            </div>

            <!-- <div class="service-icon">
              <svg *ngIf="service.icon === 'HandHelping'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M11 12h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 14"></path>
                <path d="m7 18 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9"></path>
                <path d="m2 13 6 6"></path>
              </svg>
              <svg *ngIf="service.icon === 'User'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
              <svg *ngIf="service.icon === 'HeartPulse'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
                <path d="M3.22 12H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27"></path>
              </svg>
              <svg *ngIf="service.icon === 'Activity'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
              </svg>
            </div> -->
            <h3 class="service-name">{{ service.name }}</h3>
            <p class="service-description" [innerHTML]="service.description"></p>
            <!-- <p class="service-description">{{ service.description }}</p> -->
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Emergency Contact Section -->
  <section class="section-emergency" data-testid="emergency-contact-section" data-track-section="contact">
    <div class="container">
      <div class="emergency-grid">
        <div class="emergency-item">
          <svg class="emergency-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg>
          <div>
            <p class="emergency-label">Working Hours</p>
            <p class="emergency-value">{{ clinicSettings.working_hours }}</p>
          </div>
        </div>
        <div class="emergency-item">
          <svg class="emergency-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
          </svg>
          <div>
            <p class="emergency-label">Emergency Contact</p>
            <a *ngFor="let phone of clinicSettings.phone_numbers; let idx = index" 
               [href]="'tel:' + phone" 
               class="emergency-phone"
               [attr.data-testid]="'emergency-phone-' + idx">
              {{ phone }}
            </a>
          </div>
        </div>
        <div class="emergency-item">
          <svg class="emergency-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
            <polyline points="22,6 12,13 2,6"></polyline>
          </svg>
          <div>
            <p class="emergency-label">Email Us</p>
            <a [href]="'mailto:' + clinicSettings.email" class="emergency-email" data-testid="clinic-email">
              {{ clinicSettings.email }}
            </a>
          </div>
        </div>
        <div class="emergency-item">
          <svg
            class="emergency-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M21 10c0 6-9 12-9 12s-9-6-9-12a9 9 0 1 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>

          <div>
            <p class="emergency-label">Address</p>
              <a
                [href]="clinicSettings.locationUrl"
                target="_blank"
                rel="noopener"
                class="emergency-email"
                data-testid="clinic-address"
              >
                {{ clinicSettings.address }}
              </a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- About Section -->
  <section class="section section-about" id="about" data-testid="about-section" data-track-section="about">
    <div class="container">
      <div class="about-grid">
        <div class="about-image">
          <!-- <img src="https://images.pexels.com/photos/7108284/pexels-photo-7108284.jpeg" 
               alt="Modern, bright physiotherapy clinic reception" /> -->
          <img src="assets/aboutus2.png" 
               alt="Modern, bright physiotherapy clinic reception" />
        </div>
        <div class="about-content">
          <p class="section-tagline">About Us</p>
            <h2 class="section-title">
              Precision care for confident movement
            </h2>

            <div class="about-text">
              <p>
                At <strong>ENLIGHTEN</strong>, we are dedicated to helping people <strong>move better</strong>, <strong>feel stronger</strong>, and <strong>live pain-free</strong>. We specialize in the assessment and treatment of <strong>musculoskeletal conditions</strong> using <strong>evidence-based physiotherapy techniques</strong>.
              </p>

              <p>
                Our approach focuses not just on <strong>relieving pain</strong>, but on <strong>identifying the root cause</strong> of the problem and restoring <strong>long-term function</strong>. Every patient receives <strong>personalized care</strong> tailored to their condition, lifestyle, and recovery goals.
              </p>

              <p>
                With a strong emphasis on <strong>patient education</strong>, <strong>guided exercise therapy</strong>, and <strong>hands-on treatment</strong>, we aim to empower our patients to take charge of their health and <strong>prevent future injuries</strong>.
              </p>
            </div>


          <button class="btn btn-accent btn-rounded" (click)="scrollToSection('appointment')" data-testid="about-book-appointment-btn">
            Book Consultation
          </button>
        </div>
      </div>
    </div>
  </section>

  <section class="section section-team" id="team" data-testid="team-section" data-track-section="team">
    <div class="container">
      <div class="section-header">
        <p class="section-tagline">Our Team</p>
        <h2 class="section-title">Meet Our Expert Physiotherapists</h2>
      </div>
      
      <div class="team-grid">
        <div *ngFor="let doctor of doctors; let i = index" 
             class="doctor-card"
             [attr.data-testid]="'doctor-card-' + i">
          <!-- <img [src]="doctor.imageurl" [alt]="doctor.doctorname" class="doctor-image" /> -->
          <div class="doctor-info">
            <h3 class="doctor-name">{{ doctor.doctorname }}</h3>
            <p class="doctor-qualification">{{ doctor.qualification }}</p>
            <p class="doctor-detail"><strong>Specialization:</strong> {{ doctor.specialization }}</p>
            <p class="doctor-detail"><strong>Experience:</strong> {{ doctor.experience }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Testimonials Section -->
  <section class="section section-testimonials" id="testimonials" data-testid="testimonials-section" data-track-section="testimonials">
    <div class="container">
      <div class="section-header">
        <p class="section-tagline">Testimonials</p>
        <h2 class="section-title">What Our Patients Say</h2>
      </div>
      
      <div class="testimonials-grid">
        <div *ngFor="let testimonial of testimonials; let i = index"
             class="testimonial-card"
             [attr.data-testid]="'testimonial-card-' + i">
          <div class="testimonial-rating">
            <svg *ngFor="let star of getRatingArray(testimonial.rating)" 
                 class="star-icon" viewBox="0 0 24 24" fill="currentColor">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
            </svg>
          </div>
          <p class="testimonial-content">"{{ testimonial.testimonial }}"</p>
          <p class="testimonial-author">{{ testimonial.patientName }}</p>
        </div>
      </div>
    </div>
  </section>

  <!-- Why Choose Us Section -->
  <section class="section section-why-us" data-testid="why-choose-us-section" data-track-section="whyus">
    <div class="container">
      <div class="section-header">
        <p class="section-tagline">Why Choose Us</p>
        <h2 class="section-title">Excellence in Physiotherapy Care</h2>
      </div>
<div class="why-us-grid">

  <!-- 1. Expert Physiotherapist Care (User + Check) -->
  <div class="why-us-item">
    <div class="why-us-icon-wrapper">
      <svg class="why-us-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="9" cy="7" r="4"></circle>
        <path d="M3 21a6 6 0 0 1 12 0"></path>
        <path d="M16 11l2 2 4-4"></path>
      </svg>
    </div>
    <h3 class="why-us-title">Expert Physiotherapist Care</h3>
    <p class="why-us-text">Certified professionals delivering safe, expert physiotherapy care.</p>
  </div>

  <!-- 2. Physio-Assisted Fitness (Dumbbell) -->
  <div class="why-us-item">
    <div class="why-us-icon-wrapper">
      <svg class="why-us-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M6 9v6"></path>
        <path d="M18 9v6"></path>
        <path d="M3 11v2"></path>
        <path d="M21 11v2"></path>
        <path d="M6 12h12"></path>
      </svg>
    </div>
    <h3 class="why-us-title">Physio-Assisted Fitness</h3>
    <p class="why-us-text">Strength and mobility training guided by physiotherapy expertise.</p>
  </div>

  <!-- 3. Women’s Health Specialization (Heart) -->
  <div class="why-us-item">
    <div class="why-us-icon-wrapper">
      <svg class="why-us-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l8.8 8.8 8.8-8.8a5.5 5.5 0 0 0 0-7.8Z"></path>
      </svg>
    </div>
    <h3 class="why-us-title">Women’s Health Specialization</h3>
    <p class="why-us-text">Compassionate care for women’s health and life-stage needs.</p>
  </div>

  <!-- 4. Root-Cause Treatment (Search + Cross) -->
  <div class="why-us-item">
    <div class="why-us-icon-wrapper">
      <svg class="why-us-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="11" cy="11" r="6"></circle>
        <path d="M21 21l-4.3-4.3"></path>
        <path d="M11 8v6"></path>
        <path d="M8 11h6"></path>
      </svg>
    </div>
    <h3 class="why-us-title">Root-Cause Treatment</h3>
    <p class="why-us-text">Accurate assessment focused on treating the real source of pain.</p>
  </div>

  <!-- 5. One-on-One Attention (People Interaction) -->
  <div class="why-us-item">
    <div class="why-us-icon-wrapper">
      <svg class="why-us-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="8" cy="7" r="4"></circle>
        <circle cx="16" cy="7" r="3"></circle>
        <path d="M2 21a6 6 0 0 1 12 0"></path>
      </svg>
    </div>
    <h3 class="why-us-title">One-on-One Attention</h3>
    <p class="why-us-text">Personalized sessions with complete therapist focus.</p>
  </div>

  <!-- 6. Evidence-Based Approach (Bar Chart) -->
  <div class="why-us-item">
    <div class="why-us-icon-wrapper">
      <svg class="why-us-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M4 19h16"></path>
        <path d="M7 15V9"></path>
        <path d="M12 15V5"></path>
        <path d="M17 15v-3"></path>
      </svg>
    </div>
    <h3 class="why-us-title">Evidence-Based Approach</h3>
    <p class="why-us-text">Treatments guided by scientific research and clinical data.</p>
  </div>

  <!-- 7. Advanced Therapy Methods (Target / Precision) -->
  <div class="why-us-item">
    <div class="why-us-icon-wrapper">
      <svg class="why-us-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="8"></circle>
        <circle cx="12" cy="12" r="3"></circle>
      </svg>
    </div>
    <h3 class="why-us-title">Advanced Therapy Methods</h3>
    <p class="why-us-text">Precision-based techniques for faster and effective recovery.</p>
  </div>

  <!-- 8. Nutritionist Counselling (Leaf) -->
  <div class="why-us-item">
    <div class="why-us-icon-wrapper">
      <svg class="why-us-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M4 20c10-1 14-7 16-16-9 2-15 6-16 16Z"></path>
      </svg>
    </div>
    <h3 class="why-us-title">Nutritionist Counselling</h3>
    <p class="why-us-text">Dietary guidance to enhance healing and overall health.</p>
  </div>

  <!-- 9. Holistic Wellness Care (Balance Cross) -->
  <div class="why-us-item">
    <div class="why-us-icon-wrapper">
      <svg class="why-us-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"></circle>
        <path d="M12 7v10"></path>
        <path d="M7 12h10"></path>
      </svg>
    </div>
    <h3 class="why-us-title">Holistic Wellness Care</h3>
    <p class="why-us-text">Complete care balancing physical, mental, and lifestyle health.</p>
  </div>

  <!-- 10. Premium Healing Environment (Building) -->
  <div class="why-us-item">
    <div class="why-us-icon-wrapper">
      <svg class="why-us-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <rect x="4" y="3" width="16" height="18" rx="2"></rect>
        <path d="M9 21V9"></path>
        <path d="M15 21V9"></path>
      </svg>
    </div>
    <h3 class="why-us-title">Premium Healing Environment</h3>
    <p class="why-us-text">Modern, hygienic, and calming space designed for recovery.</p>
  </div>

</div>

      <!-- <div class="why-us-grid">
        <div class="why-us-item" data-testid="why-choose-us-card-1">
          <div class="why-us-icon-wrapper">
            <svg class="why-us-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
            </svg>
          </div>
          <h3 class="why-us-title">Advanced Techniques</h3>
          <p class="why-us-text">International certifications in PNF, Pilates, and Osteopathy</p>
        </div>
        <div class="why-us-item" data-testid="why-choose-us-card-2">
          <div class="why-us-icon-wrapper">
            <svg class="why-us-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
              <path d="M3.22 12H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27"></path>
            </svg>
          </div>
          <h3 class="why-us-title">Personalized Care</h3>
          <p class="why-us-text">Tailored treatment plans for your unique needs</p>
        </div>
        <div class="why-us-item" data-testid="why-choose-us-card-3">
          <div class="why-us-icon-wrapper">
            <svg class="why-us-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
          </div>
          <h3 class="why-us-title">Experienced Team</h3>
          <p class="why-us-text">Highly skilled professionals with years of expertise</p>
        </div>
        <div class="why-us-item" data-testid="why-choose-us-card-4">
          <div class="why-us-icon-wrapper">
            <svg class="why-us-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
          </div>
          <h3 class="why-us-title">Flexible Hours</h3>
          <p class="why-us-text">Extended hours to fit your busy schedule</p>
        </div>
      </div> -->
    </div>
  </section>

  <!-- FAQ Section -->
  <section class="section section-faq" data-testid="faq-section" data-track-section="faq">
    <div class="container container-narrow">
      <div class="section-header">
        <p class="section-tagline">FAQ</p>
        <h2 class="section-title">Frequently Asked Questions</h2>
      </div>
      
      <div class="faq-list">
        <div *ngFor="let faq of faqItems" 
             class="faq-item"
             [class.faq-item-open]="faq.isOpen"
             [attr.data-testid]="'faq-' + faq.id">
          <button class="faq-trigger" (click)="toggleFaq(faq.id)">
            <span class="faq-question">{{ faq.question }}</span>
            <svg class="faq-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </button>
          <div class="faq-content" *ngIf="faq.isOpen">
            <p>{{ faq.answer }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Appointment Section -->
  <section class="section section-appointment" id="appointment" data-testid="appointment-section" data-track-section="appointment">
    <div class="container container-narrow">
      <div class="section-header">
        <p class="section-tagline">Book Now</p>
        <h2 class="section-title">Schedule Your Appointment</h2>
        <p class="section-subtitle">
          Take the first step towards recovery. Fill out the form below and we'll contact you soon.
        </p>
      </div>
      
      <div class="appointment-card">
        <form [formGroup]="appointmentForm" (ngSubmit)="onSubmit()" class="appointment-form" data-testid="appointment-form">
          <div class="form-row">
            <div class="form-group">
              <label for="patient_name" class="form-label">Full Name *</label>
              <input type="text" 
                     id="patient_name" 
                     formControlName="patient_name"
                     class="form-input"
                     data-testid="appointment-form-name" />
            </div>
            <div class="form-group">
              <label for="phone" class="form-label">Phone Number *</label>
              <input
                type="tel"
                id="phone"
                formControlName="phone"
                class="form-input"
                maxlength="10"
                inputmode="numeric"
                (input)="onPhoneInput($event)"
                data-testid="appointment-form-phone"
              />


              <!-- <input type="tel" 
                     id="phone" 
                     formControlName="phone"
                     class="form-input"
                     data-testid="appointment-form-phone" /> -->
            </div>
          </div>

          <div class="form-group">
            <label for="email" class="form-label">Email (Optional)</label>
            <input type="email" 
                   id="email" 
                   formControlName="email"
                   class="form-input"
                   data-testid="appointment-form-email" />
          </div>

          <div class="form-row">
            <div class="form-group">
              <label for="preferred_date" class="form-label">Preferred Date *</label>
              <input type="date" 
                    id="preferred_date" 
                    formControlName="preferred_date"
                    class="form-input"
                    [min]="minDate"
                    (change)="onDateChange()"
                    data-testid="appointment-form-date" />

              <!-- <input type="date" 
                     id="preferred_date" 
                     formControlName="preferred_date"
                     class="form-input"
                     data-testid="appointment-form-date" /> -->
            </div>
            <!-- <div class="form-group">
              <label for="preferred_time" class="form-label">Preferred Time</label>
              <input type="time" 
                     id="preferred_time" 
                     formControlName="preferred_time"
                     class="form-input"
                     data-testid="appointment-form-time" />
            </div> -->
          </div>
            <div class="form-group">
              <label class="form-label">Preferred Time *</label>

              <div class="time-slots">
                <button
                  type="button"
                  class="time-slot-btn"
                  *ngFor="let slot of availableSlots"
                  [disabled]="isFullDayHoliday() || bookedSlots.includes(slot) || isPastSlot(slot)"
                  [class.active]="appointmentForm.get('preferred_time')?.value === slot"
                  (click)="selectTimeSlot(slot)"
                >
                  {{ slot }}
                </button>
              </div>
            </div>
          <div class="form-group">
            <label for="service_type" class="form-label">Service Type *</label>
            <div class="service-select-container">
              <button type="button" 
                      class="service-select-trigger"
                      (click)="toggleServiceDropdown()"
                      data-testid="appointment-form-service">
                <span [class.placeholder]="!appointmentForm.get('service_type')?.value">
                  {{ appointmentForm.get('service_type')?.value || 'Select a service' }}
                </span>
                <svg class="select-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </button>
              <div class="service-select-dropdown" *ngIf="serviceDropdownOpen">
                <button type="button" 
                        *ngFor="let service of serviceTypes"
                        class="service-select-option"
                        (click)="selectService(service)">
                  {{ service }}
                </button>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="message" class="form-label">Additional Notes</label>
            <textarea id="message" 
                      formControlName="message"
                      rows="4"
                      class="form-textarea"
                      placeholder="Tell us about your condition or any specific requirements..."
                      data-testid="appointment-form-message"></textarea>
          </div>

          <button type="submit" 
                  class="btn btn-primary btn-rounded btn-full btn-lg shadow-lg"
                  [disabled]="isSubmitting"
                  data-testid="appointment-form-submit">
            {{ isSubmitting ? 'Submitting...' : 'Submit Appointment Request' }}
          </button>
        </form>
      </div>
    </div>
  </section>

  <!-- Footer -->
  <footer class="footer" data-testid="footer" data-track-section="footer">
    <div class="container">
      <div class="footer-grid">
        <div class="footer-brand">
          <h3 class="footer-logo">Enlighten Physiotherapy</h3>
          <p class="footer-description">
            Professional and compassionate physiotherapy services for all age groups. Your wellness, our priority.
          </p>
        </div>
        <div class="footer-contact">
          <h4 class="footer-heading">Contact Us</h4>
          <div class="footer-contact-list">
            <p *ngFor="let phone of clinicSettings.phone_numbers">
              <svg class="footer-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
              </svg>
              <a [href]="'tel:' + phone">{{ phone }}</a>
            </p>
            <p>
              <svg class="footer-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
              <a [href]="'mailto:' + clinicSettings.email">{{ clinicSettings.email }}</a>
            </p>
          </div>
        </div>
          <div class="footer-hours">
            <h4 class="footer-heading">Working Hours</h4>

            <p class="footer-hours-text">
              <svg class="footer-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
              {{ clinicSettings.working_hours }}
            </p>

            <!-- Address below Working Hours -->
            <p class="footer-hours-text footer-address">
              <svg
                class="footer-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M21 10c0 6-9 12-9 12s-9-6-9-12a9 9 0 1 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>

              <a
                [href]="clinicSettings.locationUrl"
                target="_blank"
                rel="noopener"
              >
                {{ clinicSettings.address }}
              </a>
            </p>
          </div>

      </div>
      <div class="footer-bottom">
        <p>&copy; {{ currentYear }} Enlighten Physiotherapy Spot. All rights reserved.</p>
      </div>
    </div>
  </footer>
</div>